import { FeaturedItemsContent } from '@models';
import { BaseContentComponent } from '../base-content.component';
import { FeaturedItemsContentItemComponent } from '../featured-items-content-item/featured-items-content-item.component';
import defaultHtml from './featured-items-content.component.hbs';

export class FeaturedItemsContentComponent extends BaseContentComponent<FeaturedItemsContent> {
    protected override customTemplatePropertyName = 'featuredItemsContent';
    protected override defaultHtml = defaultHtml;

    protected getContentHtml(template: HandlebarsTemplateDelegate): string {
        if (!this.data?.items?.length) {
            return '';
        }

        const html = template(this.data);

        return html;
    }

    protected bindChildElements(): void {
        this.shadowRoot?.querySelectorAll<FeaturedItemsContentItemComponent>('hawksearch-featured-items-content-item').forEach((component, index) => {
            component.data = this.data?.items?.[index];
        });
    }
}
